'use strict';

module.exports = function (column) {

  if (!this.opts.orderBy) return;

  this.orderBy.column = this.opts.orderBy.column;
  this.orderBy.ascending = this.opts.orderBy.hasOwnProperty('ascending') ? this.opts.orderBy.ascending : true;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/init-order-by.js